<micro-lookup domain="air" obj="airtimeCarriers" url="/air/airtimeCarriers" [key]="airtimeCarrierId" [link]="link"></micro-lookup>
